import {
    DestroyRef,
    Directive,
    TemplateRef,
    effect,
    inject,
    input,
} from '@angular/core';
import {
    BuildingBannerSlotRegistry,
    type BuildingBannerSlotKey,
} from './building-banner-slot-registry';

@Directive({
    selector: 'ng-template[qpxBuildingBannerSlotEntry]',
})
export class BuildingBannerSlotEntry {
    //#region Dependency injection
    private readonly template = inject(TemplateRef<unknown>);
    private readonly registry = inject(BuildingBannerSlotRegistry);
    private readonly destroyRef = inject(DestroyRef);
    //#endregion

    //#region Inputs
    public readonly key = input.required<BuildingBannerSlotKey>({
        alias: 'qpxBuildingBannerSlotEntry',
    });
    public readonly order = input(100, {
        // eslint-disable-next-line @angular-eslint/no-input-rename
        alias: 'qpxBuildingBannerSlotEntryOrder',
    });
    //#endregion

    //#region Lifecycle hooks
    constructor() {
        effect(() => {
            this.registry.setEntry(this.key(), this.template, this.order());
        });

        this.destroyRef.onDestroy(() => {
            this.registry.setEntry(this.key(), null, this.order());
        });
    }
    //#endregion
}
